<template>
  <div class="transportDeliveryOrder">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <!--内容区域-->
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"><span></span>可放货额度统计</div>
        </template>
        <div class="collapse-content">
          <el-button type="primary" class="btn" icon="el-icon-plus" @click="handleExport"
            >导出</el-button
          >
          <sirui-table
            ref="siruiTable"
            :buttonList="menuButtonList"
            :loading="load"
            :data="tableData"
            maxHeight="420"
            :paging="true"
            :columns="columnList"
            @chooseClick="chooseClick"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
            @handleSelectionChange="handleSelectionChange"
            @dblclickEvent="dblclickEvent"
          >
            <vxe-table-column
              v-for="(item, index) in columnList"
              :key="index"
              :fixed="item.fixed"
              :visible="item.visible"
              :width="item.width || 120"
              :sortable="item.sortable"
              :field="item.field"
              :formatter="item.formatter"
              :params="item.params"
              :type="item.type"
              :title="item.title ? $t(item.title) : null"
            >
              <template slot-scope="scope">
                <span v-if="item.dictType">
                  {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
                </span>
                <span v-else-if="item.format">
                  {{ scope.row[item.field] | formatTableColumn(item.format) }}
                </span>
                <span v-else>{{ scope.row[item.field] }}</span>
              </template>
            </vxe-table-column>
          </sirui-table>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre"><span></span>可放货额度币种明细</div>
        </template>
        <div class="collapse-content">
          <el-button type="primary" class="btn" icon="el-icon-plus" @click="handleExportCurrency"
            >导出</el-button
          >
          <sirui-table
            ref="siruiTableCur"
            :loading="load"
            :data="tableDataCur"
            maxHeight="400"
            :paging="false"
            @chooseClick="chooseClick"
            @handleCurrentChange="handleCurrentChange"
            @dblclickEvent="dblclickEventCur"
          >
            <vxe-table-column
              v-for="(item, index) in columnListCur"
              :key="index"
              :fixed="item.fixed"
              :width="item.width || 120"
              :sortable="item.sortable"
              :field="item.field"
              :title="item.title"
            >
              <template slot-scope="scope">
                <span v-if="item.dictType">
                  {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
                </span>
                <span v-else-if="item.format">
                  {{ scope.row[item.field] | formatTableColumn(item.format) }}
                </span>
                <span v-else>{{ scope.row[item.field] }}</span>
              </template>
            </vxe-table-column>
          </sirui-table>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/credit/orderLadingLimit.js';
  import DataBaseAPI from '@/api/dataBase';
  import tableMixins from '@/common/mixins/table.js';
  // import siruiUpload from '@/components/SiruiUpload';
  // import loading from '@/common/js/load.js'; //loading
  import XEUtils from 'xe-utils';
  export default {
    name: 'orderLadingLimitList',
    mixins: [tableMixins],
    components: {
      // siruiUpload,
    },
    data() {
      return {
        // action: API.IMPORT,
        query: {
          controlareaCode: null,
          bizDate: null,
          partnerKey: null,
        },
        queryCurrcy: {
          controlareaCode: null,
          partnerNo: null,
          bizDate: null,
        },
        activeNames: ['1', '2'], //默认展开那些面板，
        tableData: [],
        tableDataCur: [],
        companyList: [], //公司列表
        departmentList: [], //部门列表
        postDate: '',
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        tokenInfo() {
          return {
            access_token: this.userInfo.access_token,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            tenantCode: this.userInfo.tenantCode,
          };
        },
      }),
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'controlareaCode',
            name: '控制范围',
            placeholder: '请选择控制范围',
            type: 'treeSelect',
            apiUrl: DataBaseAPI.LIST_TREE,
            apiData: {
              tenantCode: this.userInfo.tenantCode,
              adminFlag: this.userInfo.adminFlag,
              currentStatus: '0',
            },
            clearable: false,
            normalizerFlag: true,
          },
          // {
          //   type: 'searchTableSpec',
          //   prop: 'partnerNo',
          //   isMultiple: true,
          //   name: "合作伙伴",
          //   searchType: 'partner',
          //   extraData:{
          //     departmentCode:this.query.inboundDepartmentCode,
          //     companyCode:this.query.inboundCompanyCode
          //   },
          //   // currentValue: this.baseData.partnerNo,
          //   // span: 12,
          // },
          /* {
          prop: "partnerKey",
          type: "input",
          isMultiple: true,
          name: "合作伙伴名称/编码",
        }, */
          {
            // 合作伙伴名称
            type: 'searchTableSpec',
            prop: 'partnerKey',
            isMultiple: true,
            name: '合作伙伴',
            searchType: 'supplier',
            extraData: {
              partnerTypes: 'HZHB03,HZHB02,HZHB01',
              requestStatus: 'ZT03',
              adminFlag: this.userInfo.adminFlag,
              // department:this.userInfo.department,
              company: this.query.controlareaCode,
            },
          },
          {
            prop: 'bizDate',
            name: '日期',
            placeholder: '请选择日期',
            type: 'date',
          },
        ];
      },

      //表格显示字段
      columnListDefault() {
        return [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
          },
          { field: 'controlareaCode', title: '控制范围编码', visible: true },
          {
            field: 'controlareaName',
            title: '控制范围描述',
            visible: true,
            width: 200,
          },
          {
            field: 'partnerType',
            title: '合作伙伴类型',
            visible: true,
            type: 'dict',
            dictType: 'partner_type',
          },
          {
            field: 'partnerNo',
            title: '合作伙伴编码',
            visible: true,
            width: 200,
          },
          {
            field: 'partnerName',
            title: '合作伙伴名称',
            visible: true,
            width: 240,
          },
          {
            field: 'creditLimitAmount',
            title: '赊销额度',
            visible: true,
            format: 'formatAmountRound',
            width: 200,
          },
          {
            field: 'ladingLimitAmount',
            title: '可放货额度（人民币）',
            visible: true,
            format: 'formatAmountRound',
            width: 200,
          },
        ];
      },

      columnListCur() {
        return [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
          },
          { field: 'controlareaCode', title: '控制范围编码', visible: true },
          {
            field: 'controlareaName',
            title: '控制范围描述',
            visible: true,
            width: 180,
          },
          {
            field: 'partnerNo',
            title: '合作伙伴编码',
            visible: true,
            width: 180,
          },
          {
            field: 'partnerName',
            title: '合作伙伴名称',
            visible: true,
            width: 200,
          },
          {
            field: 'currencyCode',
            title: '币种',
            visible: true,
            // dictType: "all_currency",
          },
          {
            field: 'receiveAmount',
            title: '收款（原币）',
            visible: true,
            format: 'formatAmountRound',
          },
          {
            field: 'refundAmount',
            title: '退款（原币）',
            visible: true,
            format: 'formatAmountRound',
          },
          {
            field: 'ladingAmount',
            title: '发货金额（原币）',
            visible: true,
            format: 'formatAmountRound',
          },
          {
            field: 'salesReturnAmount',
            title: '销售退货（原币）',
            visible: true,
            format: 'formatAmountRound',
          },
          {
            field: 'balanceAmount',
            title: '客户余额（原币）（收-发）',
            visible: true,
            format: 'formatAmountRound',
            width: 200,
          },
          {
            field: 'companyBalanceAmount',
            title: '客户余额（人民币）（收-发）',
            visible: true,
            format: 'formatAmountRound',
            width: 200,
          },
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      // //制单人默认
      // this.query.inboundCreatePersonNo = this.userInfo.userCode;
      // this.query.inboundCreatePersonName = this.userInfo.userName;
      // console.log(this.query.inboundCreatePersonNo);
      // console.log(this.query.inboundCreatePersonName);
      // this.initDepartment();
      this.getButtonList();
      this.getData();
    },
    methods: {
      //获取数据
      getData() {
        this.tableDataCur = [];
        const query = this.setSearchParams();
        const routeQuery = this.$route.query;
        console.log(XEUtils.isEmpty(routeQuery));
        if (!XEUtils.isEmpty(routeQuery)) {
          query.partnerKey = routeQuery.partnerCode;
          query.bizDate = routeQuery.validDate;
          console.log(query);
        }
        this.load = true;
        this.$axios.post(API.LADING_LIMIT_LIST_API, query).then((res) => {
          this.load = false;
          console.log(res);
          if (0 == res.data.code) {
            this.tableData = res.data.data.records || [];
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //获取数据
      getDataCur(e) {
        this.tableDataCur = e.row.currencyList ? e.row.currencyList : [];
        this.queryCurrcy.controlareaCode = e.row.controlareaCode;
        this.queryCurrcy.partnerNo = e.row.partnerNo;
        this.queryCurrcy.bizDate = this.query.bizDate;
      },
      handleExport() {
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = 'idStr=';
          // let ids = changeList.forEach((item) => {
          //   str += '' + item.id + ',';
          // });
          str = str.substring(0, str.lastIndexOf(','));
          window.location.href = `${this.baseUrl}${API.EXPORT_ORDER_LADING_LIMIT}?${str}&access_token=${this.tokenInfo.access_token}`;
        } else {
          let query = this.filterEmpty(this.query);
          Object.keys(query).forEach((value) => {
            if (XEUtils.isArray(query[value])) {
              query[value + 'Str'] = query[value].join(',');
              delete query[value];
            }
          });
          const params = XEUtils.serialize(query);
          window.location.href = `${this.baseUrl}${API.EXPORT_ORDER_LADING_LIMIT}?${params}&access_token=${this.tokenInfo.access_token}`;
        }
      },
      handleExportCurrency() {
        if (this.tableDataCur.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        let query = this.filterEmpty(this.queryCurrcy);
        Object.keys(query).forEach((value) => {
          if (XEUtils.isArray(query[value])) {
            query[value + 'Str'] = query[value].join(',');
            delete query[value];
          }
        });
        const params = XEUtils.serialize(this.queryCurrcy);
        window.location.href = `${this.baseUrl}${API.EXPORT_ORDER_LADING_LIMIT_CURRENCY}?${params}&access_token=${this.tokenInfo.access_token}`;
      },
      // 搜索按钮（重写）
      searchBtnClick(query) {
        console.log(query);
        this.tableDataCur = [];
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        this.getData();
      },
      // 查询参数整理
      setSearchParams() {
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        console.log(this.query);
        const query = { ...this.query, pageSize, pageNum };
        // if(query.partnerNo && query.partnerNo.length > 0){
        //   const { partnerCode } = query.partnerNo[0];
        //   query.partnerNo = partnerCode
        // }
        if (query.partnerKey && query.partnerKey.length > 0) {
          const { partnerCode } = query.partnerKey[0];
          query.partnerKey = partnerCode;
        }
        return query;
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type === 'export') {
          this.export();
        }
      },

      // 导出
      export() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'ids=' + item.id + '&';
          // });
          window.location.href = `${this.baseUrl}${API.POST_LIST_EXPORT}?${str}access_token=${this.userInfo.access_token}`;
        } else {
          let params = this.setSearchParams();
          params = XEUtils.serialize(params);
          window.location.href = `${this.baseUrl}${API.POST_LIST_EXPORT}?${params}&access_token=${this.userInfo.access_token}`;
        }
      },

      // 跳转详情页
      dblclickEvent(e) {
        console.log(e.row);
        this.getDataCur(e);
      },

      //双击事件
      dblclickEventCur(e) {
        let path = {
          path: '/credit/orderLadingLimitDetail',
          name: 'orderLadingLimitDetail',
          meta: {
            keepAlive: false,
          },
          query: {
            controlareaCode: e.row.controlareaCode,
            partnerNo: e.row.partnerNo,
            partnerName: e.row.partnerName,
            currencyCode: e.row.currencyCode,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .collapse-main-content {
    margin-top: 10px;
  }
</style>
